import { PublicodesSimulationConfig } from '@/domaine/PublicodesSimulationConfig'

import { configEntrepriseIndividuelle } from '../entreprise-individuelle/simulationConfig'

export const configEirl: PublicodesSimulationConfig =
	configEntrepriseIndividuelle
